// extracted by mini-css-extract-plugin
export default {"container":"LibraryCrud_container__UGH6M","main":"LibraryCrud_main__qIvIi","nav":"LibraryCrud_nav__yKcU1","active":"LibraryCrud_active__W5I1w"};